import { ContentInfo } from "../ContentInfo";
import { ContentEntryPublishRenderData } from "./ContentEntryPublishRenderData";
import { TopicLeaf } from "../TopicLeaf";
import { ContentEntryPublishRenderDescriptor } from "../ContentEntryPublishRenderDescriptor";
import { ConceptLink } from '../Concept/ConceptLink';

export class ContentEntryDisplayData{
    public RenderData: ContentEntryPublishRenderData;
    public Lineage: ContentInfo[] = [];
    public HidePopup: boolean;
    public TimeIndex: string;
    public FacebookAppId: string;
    public LogoUrl: string;
    public SeeAlso: ConceptLink[];


    public static InstantiateContentEntryDisplayData(topic: TopicLeaf, parentTopic: TopicLeaf, theContent: ContentEntryPublishRenderDescriptor)
    {
        var topic1: ContentInfo = TopicLeaf.topicLeaf2ContentInfo(topic);
        var topic2: ContentInfo = TopicLeaf.topicLeaf2ContentInfo(parentTopic);
  
        var contentEntry: ContentEntryDisplayData = new ContentEntryDisplayData();
        contentEntry.Lineage = new Array();
        contentEntry.Lineage.push(topic1);
        contentEntry.Lineage.push(topic2);
        var contentEntryData: ContentEntryPublishRenderData = new ContentEntryPublishRenderData();
        contentEntryData.ContentEntryDescriptor = theContent;
        contentEntry.RenderData = contentEntryData;
        return contentEntry; 
    }

    public static InstantiateOneLevelContentEntryDisplayData(topic: TopicLeaf, theContent: ContentEntryPublishRenderDescriptor)
    {
        var topic1: ContentInfo = TopicLeaf.topicLeaf2ContentInfo(topic);
  
        var contentEntry: ContentEntryDisplayData = new ContentEntryDisplayData();
        contentEntry.Lineage = new Array();
        contentEntry.Lineage.push(topic1);
        var contentEntryData: ContentEntryPublishRenderData = new ContentEntryPublishRenderData();
        contentEntryData.ContentEntryDescriptor = theContent;
        contentEntry.RenderData = contentEntryData;
        return contentEntry; 
    }

}